<template>
  <component :is="linkComponent" v-bind="componentProps">
    <Image
      v-if="content.icon"
      :source="content.icon"
      class="small-content-card__image"
    />
    <div v-else class="small-content-card__dot" />
    <p v-if="content.title" class="small-content-card__title">{{ content.title }}</p>
    <p v-if="content.description">{{ content.description }}</p>
  </component>
</template>

<script>
import { HasContentMixin } from '@/mixins'
import { Image } from '@/components/global'
import { RouterLink } from 'vue-router'

export default {
  name: 'SmallContentLink',
  mixins: [HasContentMixin],
  components: {
    Image,
    RouterLink
  },
  computed: {
		isExternal() {
      if (!this.content.link) return false
      return new URL(this.content.link).origin !== window.location.origin
    },
    linkComponent() {
      if (this.content.link) {
        return this.isExternal ? 'a' : 'RouterLink'
      }
      return 'div'
    },
    componentProps() {
      if (this.content.link) {
        return this.isExternal
          ? { href: this.content.link, target: '_blank' }
          : { to: this.content.link }
      }
      return {}
    }
  }
}
</script>